import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import ResizeObserver from 'resize-observer-polyfill';

const DEFAULT_HEIGHT = 45;

export const useBannerResize = ({
  enabled,
  ref,
  selector,
}: {
  enabled: boolean;
  ref: React.RefObject<HTMLDivElement>;
  selector: string;
}) => {
  const [height, setHeight] = useState(DEFAULT_HEIGHT);
  const history = useHistory();

  useEffect(() => {
    let resizeObserver: ResizeObserver;
    const target = ref.current?.querySelector<HTMLDivElement>(selector);

    if (enabled && target && ResizeObserver) {
      resizeObserver = new ResizeObserver(([entry]: any) => {
        const {
          contentRect: { height: contentHeight },
        } = entry;
        const offsetHeight = Math.ceil(contentHeight);
        setHeight(offsetHeight > DEFAULT_HEIGHT ? offsetHeight : DEFAULT_HEIGHT);
      });

      if (resizeObserver?.observe) {
        resizeObserver.observe(target);
      }
    }
    return () => {
      if (resizeObserver && resizeObserver?.disconnect) resizeObserver.disconnect();
    };
  }, [enabled, ref, history, selector]);

  return { height };
};
